import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import styles from './Contact.module.css';

const Contact = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.15
  });

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    phone: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
  };

  return (
    <section className={styles.section} id="contact" data-section="contact" ref={ref}>
      <div className={styles.container}>

        <motion.div
          className={styles.header}
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <div className={styles.headerTop}>
            <div className={styles.sectionLabel}>Contact Us</div>

          </div>
          <h2 className={styles.title}>Get Started with ScoreX</h2>
        </motion.div>

        <motion.div
          className={styles.contentWrapper}
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : {}}
          transition={{ duration: 0.6, delay: 0.1 }}
        >

          {/* Left Side - Form */}
          <div className={styles.formPanel}>
            <form onSubmit={handleSubmit} className={styles.form}>
              <div className={styles.formRow}>
                <div className={styles.formGroup}>
                  <label htmlFor="name" className={styles.label}>Full Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className={styles.input}
                    placeholder="Enter your full name"
                    required
                  />
                </div>

                <div className={styles.formGroup}>
                  <label htmlFor="email" className={styles.label}>Work Email *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className={styles.input}
                    placeholder="you@company.com"
                    required
                  />
                </div>
              </div>

              <div className={styles.formRow}>
                <div className={styles.formGroup}>
                  <label htmlFor="company" className={styles.label}>Institution Name *</label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    value={formData.company}
                    onChange={handleChange}
                    className={styles.input}
                    placeholder="Your institution"
                    required
                  />
                </div>

                <div className={styles.formGroup}>
                  <label htmlFor="phone" className={styles.label}>Phone Number</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className={styles.input}
                    placeholder="+254 700 000 000"
                  />
                </div>
              </div>

              <div className={styles.formGroup}>
                <label htmlFor="message" className={styles.label}>How can we help? *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  className={styles.textarea}
                  placeholder="Tell us about your credit risk management needs..."
                  rows="5"
                  required
                ></textarea>
              </div>

              <button type="submit" className={styles.submitButton}>
                Send Message
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <path d="M6.75 13.5L11.25 9L6.75 4.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
            </form>
          </div>

          {/* Right Side - Info */}
          <div className={styles.infoPanel}>
            <div className={styles.infoSection}>
              <h3 className={styles.infoTitle}>Contact Information</h3>

              <div className={styles.infoList}>
                <div className={styles.infoItem}>
                  <div className={styles.infoIcon}>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path d="M17.5 8.33333C17.5 14.1667 10 19.1667 10 19.1667C10 19.1667 2.5 14.1667 2.5 8.33333C2.5 6.34420 3.29018 4.43655 4.6967 3.03007C6.10322 1.62360 8.01088 0.833328 10 0.833328C11.9891 0.833328 13.8968 1.62360 15.3033 3.03007C16.7098 4.43655 17.5 6.34420 17.5 8.33333Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      <circle cx="10" cy="8.33333" r="2.5" stroke="currentColor" strokeWidth="1.5" />
                    </svg>
                  </div>
                  <div className={styles.infoContent}>
                    <div className={styles.infoLabel}>Visit Us</div>
                    <div className={styles.infoValue}>
                      Stellato Mall, 3rd Floor<br />
                      Ngong Road, Nairobi<br />
                      Kenya
                    </div>
                  </div>
                </div>

                <div className={styles.infoItem}>
                  <div className={styles.infoIcon}>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path d="M18.3333 14.1V16.6C18.3342 16.8321 18.2866 17.0618 18.1936 17.2744C18.1006 17.4871 17.9643 17.678 17.7933 17.8349C17.6222 17.9918 17.4203 18.1112 17.2005 18.1856C16.9806 18.26 16.7477 18.288 16.5167 18.2683C13.9523 17.9892 11.489 17.1126 9.32498 15.7083C7.31151 14.4289 5.60443 12.7218 4.32499 10.7083C2.91663 8.53426 2.03993 6.05908 1.76665 3.48334C1.74695 3.25293 1.77477 3.02067 1.84894 2.80139C1.9231 2.58211 2.04204 2.38064 2.19831 2.2097C2.35457 2.03875 2.54469 1.90219 2.75649 1.80869C2.9683 1.7152 3.19737 1.6672 3.42915 1.66667H5.92915C6.32962 1.66268 6.71813 1.80587 7.02323 2.06964C7.32833 2.33342 7.53083 2.69954 7.59165 3.09584C7.70517 3.88693 7.91577 4.66143 8.21665 5.40417C8.32741 5.68081 8.35873 5.98235 8.30716 6.27556C8.25558 6.56876 8.1229 6.84206 7.92498 7.06417L6.84165 8.14751C7.99535 10.2453 9.67186 11.9218 11.7692 13.0758L12.8525 11.9925C13.0746 11.7946 13.3479 11.6619 13.6411 11.6103C13.9343 11.5588 14.2359 11.5901 14.5125 11.7008C15.2552 12.0017 16.0297 12.2123 16.8208 12.3258C17.2213 12.3872 17.5911 12.5937 17.8553 12.9038C18.1195 13.2138 18.2603 13.6078 18.2525 14.0125L18.3333 14.1Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </div>
                  <div className={styles.infoContent}>
                    <div className={styles.infoLabel}>Call Us</div>
                    <a href="tel:+254708277848" className={styles.infoValue}>+254 708 277 8484</a>
                    <a href="tel:+254700000000" className={styles.infoValue}>+254 700 000 000</a>
                  </div>
                </div>

                <div className={styles.infoItem}>
                  <div className={styles.infoIcon}>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <rect x="2.5" y="4.16667" width="15" height="11.6667" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
                      <path d="M2.5 6.66667L10 11.6667L17.5 6.66667" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </div>
                  <div className={styles.infoContent}>
                    <div className={styles.infoLabel}>Email Us</div>
                    <a href="mailto:hello@scorex.io" className={styles.infoValue}>hello@scorex.io</a>
                    <a href="mailto:sales@scorex.io" className={styles.infoValue}>sales@scorex.io</a>
                  </div>
                </div>

                <div className={styles.infoItem}>
                  <div className={styles.infoIcon}>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <circle cx="10" cy="10" r="7.5" stroke="currentColor" strokeWidth="1.5" />
                      <path d="M10 5.83333V10L12.5 11.6667" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                    </svg>
                  </div>
                  <div className={styles.infoContent}>
                    <div className={styles.infoLabel}>Business Hours</div>
                    <div className={styles.infoValue}>
                      Mon - Fri: 8:00 AM - 6:00 PM<br />
                      Sat: 9:00 AM - 2:00 PM
                    </div>
                  </div>
                </div>
              </div>
            </div>

            
          </div>

        </motion.div>

      </div>
    </section>
  );
};

export default Contact;